var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 14.5001C20.526 14.5001 20.75 14.7241 20.75 15.0001V20.0001C20.75 20.2761 20.526 20.5001 20.25 20.5001H1.25C0.974 20.5001 0.75 20.2761 0.75 20.0001V15.0001C0.75 14.7241 0.974 14.5001 1.25 14.5001C1.526 14.5001 1.75 14.7241 1.75 15.0001V19.5001H19.75V15.0001C19.75 14.7241 19.974 14.5001 20.25 14.5001ZM10.75 0.5C11.0262 0.5 11.25 0.724 11.25 1V13.794L15.3965 9.64775C15.5917 9.4525 15.9082 9.4525 16.1035 9.64775C16.2987 9.843 16.2987 10.1597 16.1035 10.3547L11.1045 15.3538C11.007 15.4513 10.879 15.5 10.7509 15.5C10.6229 15.5 10.4952 15.4513 10.3975 15.3538L5.39645 10.355C5.2012 10.1598 5.2012 9.84325 5.39645 9.64775C5.5912 9.4525 5.9082 9.45275 6.10345 9.64775L10.25 13.7922V1C10.25 0.724 10.474 0.5 10.75 0.5Z",
    fill: "#E81111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Download.f339cd123116c26e9c5bf5a6f44d1f7d.svg";